export const FETCH_DATA_RESULTS = "FETCH_DATA_RESULTS"
export const FETCHED_DATA_RESULTS = "FETCHED_DATA_RESULTS"
export const SEARCH_RESULT_ISICS = "SEARCH_RESULT_ISICS"
export const SELECT_RESULT_ISIC = "SELECT_RESULT_ISIC"
export const SELECT_ALL_RESULT_ISICS = "SELECT_ALL_RESULT_ISICS"

export function fetchIfNededDataResults() {


  return (dispatch, getState) => {

    // if (getState().dataResultsReducer.dataResults) {
    //   return;
    // }

    dispatch(fetchDataResults())

    return fetch('/ndap/national-data/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: getState().internationalizationReducer.activeLangCode
      },
      body: JSON.stringify({
        indicators: getState().indicatorsReducer.indicators.filter(x => x.selectedOnResult).length > 0 ? [getState().indicatorsReducer.indicators.filter(x => x.selectedOnResult)[0]].map(x => ({id: x.id, n: x.n, code: x.code})) : [getState().indicatorsReducer.indicators.filter(x => x.selected)[0]].map(x => ({id: x.id, n: x.n, code: x.code})),
        isics: getState().isicsReducer.isics.filter(x => x.selected).map(x => ({id: x.id, n: x.n, c: x.c})),
        regions: getState().regionsReducer.regions.filter(x => x.selectedOnResult).length > 0 ? [getState().regionsReducer.regions.filter(x => x.selectedOnResult)[0]].map(x => ({id: x.id, n: x.n})) : [getState().regionsReducer.regions.filter(x => x.selected)[0]].map(x => ({id: x.id, n: x.n})),
        years: getState().yearsReducer.years.filter(x => x.selected).map(x => ({y: x.y}))
      }),
    }).then((response) => {
      if (!response.ok)
        throw Error(response.statusText)
      return response
    }).then((response) => response.json())
      .then((responseJson) => {
        // responseJson.unshift(["Activity", "Indicators", "Regions", "Value", "Years"]);
        dispatch(fetchedDataResults(responseJson, getState().isicsReducer.isics, getState().yearsReducer.years))
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

export function fetchDataResults() {
  return { type: FETCH_DATA_RESULTS };
}

export function fetchedDataResults(data, isics, years) {
  return { type: FETCHED_DATA_RESULTS, data, isics, years }
}

export function searchResultIsics(searchParameter, activeLangCode) {
  return { type: SEARCH_RESULT_ISICS, searchParameter, activeLangCode }
}

export function selectResultIsic(resultIsicId) {
  return { type: SELECT_RESULT_ISIC, resultIsicId }
}

export function selectAllResultIsics(selectionStatus) {
  return { type: SELECT_ALL_RESULT_ISICS, selectionStatus }
}


// WEBPACK FOOTER //
// ./src/features/modules/survey-data-visualization/data-results/DataResultsActions.js